import { type ReactNode, createContext, useContext, useState } from "react";

interface LayoutContextType {
	showNavbar: boolean;
	setShowNavbar: (show: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | null>(null);

/**
 * Use this hook to access the layout context and enable conditional rendering of the navbar
 * @returns
 */
export function useLayout() {
	const context = useContext(LayoutContext);
	if (!context) {
		throw new Error("useLayout must be used within a LayoutProvider");
	}
	return context;
}

interface LayoutProviderProps {
	children: ReactNode;
}

/**
 * Use this component to wrap your app in a layout provider
 * @param children
 * @returns
 */
export function LayoutProvider({ children }: LayoutProviderProps) {
	const [showNavbar, setShowNavbar] = useState(true);

	// Add logging to debug navbar visibility changes
	const setShowNavbarWithLogging = (show: boolean) => {
		console.log("Layout context: Setting navbar visibility to", show);
		setShowNavbar(show);
	};

	return (
		<LayoutContext.Provider
			value={{
				showNavbar,
				setShowNavbar: setShowNavbarWithLogging,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
}
